import React, { Component } from 'react';
import { connect } from 'react-redux';
import MicroFrontend from './MicroFrontend';

class Home extends Component {
  render() {
    if (
      this.props.profile.me &&
      this.props.profile.me.isFetching === false &&
      this.props.profile.chat &&
      this.props.profile.chat.isFetching === false
    ) {
      return (
        <div>
          {console.log('rendering')}
          <div className="right_content">
            <div className="main_content">
              <MicroFrontend
                history={this.props.history}
                host={process.env.REACT_APP_TELEKARDIA_HOST}
                name="Telekardia"
                userstate={this.props.profile}
                app="telekardia"
              />
            </div>
          </div>
        </div>
      );
    }
    return <div />;
  }
}

const mapStateToProps = state => {
  return {
    profile: {
      me: state.app.dataSources.me,
      chat: state.app.dataSources.chatProfile,
    },
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/telekardia/components/MicroFrontEndComponent.jsx